var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmail16Px = function SvgIconEmail16Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconEmail16px_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 3.594c.023-.085.043-.17.071-.254.189-.573.722-.961 1.34-.964.979-.004 1.957-.001 2.936-.001h10.168c.713 0 1.263.398 1.432 1.045.035.134.05.277.05.416Q16.002 8 16 12.163c0 .86-.606 1.463-1.467 1.463H1.505c-.782 0-1.292-.4-1.482-1.162q-.01-.03-.023-.057zm1.64-.273c.044.049.073.083.105.115l5.834 5.853c.267.268.576.266.848-.006l5.835-5.854c.03-.03.056-.065.093-.107zm-.013 9.354h12.746L10.35 8.688c-.03.029-.072.067-.111.107q-.584.587-1.17 1.172c-.614.61-1.525.61-2.138 0q-.353-.353-.706-.708l-.573-.573zm-.682-.72 3.997-3.958L.945 4.033zm14.109-7.927L11.04 8.003l4.013 3.976z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconEmail16px_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 2.374h16v11.253H0z"
  })))));
};
export default SvgIconEmail16Px;